import React, { useEffect, useMemo } from 'react';
import { ReactTable } from '@components';
import { useDispatch, useSelector } from 'react-redux';
import { apiGetOverStatistics } from '@store';
import { MRT_ToggleGlobalFilterButton } from 'material-react-table';

const OverallStatistics = ({ selectedPortfolio }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        if (selectedPortfolio.name !== '' && selectedPortfolio.uuid !== '') {
            dispatch(
                apiGetOverStatistics({
                    portfolio_name: selectedPortfolio.name,
                    portfolio_uuid: selectedPortfolio.uuid
                })
            );
        }
    }, [selectedPortfolio]);

    const { overallStatistics, isGetOverStatisticsLoading } = useSelector(
        (state) => state.hedges
    );

    console.log('overallStatistics', overallStatistics.Ret);

    // sort by year and by the month (calendar order)
    const monthOrder = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];
    const sortedData = overallStatistics?.Ret?.slice()?.sort((a, b) => {
        if (a?.Year !== b?.Year) {
            return a.Year - b.Year;
        }
        const monthA = monthOrder.indexOf(a.Month);
        const monthB = monthOrder.indexOf(b.Month);
        return monthA - monthB;
    });

    const columns = useMemo(
        () => [
            {
                header: 'Month',
                id: 'Month',
                accessorFn: ({ Month }) => Month || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            },
            {
                header: 'Year',
                id: 'Year',
                accessorFn: ({ Year }) => Year || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            },
            {
                header: 'Hedge Vol (MW)',
                id: 'TotalVol',
                accessorFn: ({ TotalVol }) =>
                    TotalVol.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') ||
                    '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                Footer: () => (
                    <>
                        {' '}
                        Total:{' '}
                        <span className="text-green-700">
                            {overallStatistics?.Totalhedgevol
                                ? overallStatistics?.Totalhedgevol
                                : '0.00'}
                        </span>{' '}
                    </>
                )
            },
            {
                header: 'Hedge Amount (EUR)',
                id: 'TotalCost',
                accessorFn: ({ TotalCost }) =>
                    TotalCost.toFixed(2).replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        ','
                    ) || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                Footer: () => (
                    <>
                        {' '}
                        Total:{' '}
                        <span className="text-green-700">
                            {overallStatistics?.Totalhedgecost
                                ? overallStatistics?.Totalhedgecost
                                : '0.00'}
                        </span>{' '}
                    </>
                )
            },
            {
                header: 'Average Price (EUR/MW)',
                id: 'contract',
                Cell: ({ row }) =>
                    isNaN(row?.original?.TotalCost / row?.original?.TotalVol)
                        ? '0.00'
                        : (row?.original?.TotalCost / row?.original?.TotalVol)
                              .toFixed(3)
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            },
            {
                header: 'VaR (EUR)',
                id: 'Var',
                accessorFn: ({ Var }) => Var.toFixed(2) || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                Footer: () => (
                    <>
                        {' '}
                        Total:{' '}
                        <span className="text-green-700">
                            {overallStatistics?.Totalvar
                                ? overallStatistics?.Totalvar
                                : '0.00'}
                        </span>{' '}
                    </>
                )
            }
        ],
        [
            overallStatistics?.Totalhedgecost,
            overallStatistics?.Totalhedgevol,
            overallStatistics?.Totalvar
        ]
    );

    return (
        <ReactTable
            headerText={'Overall Statistics'}
            columns={columns}
            data={sortedData || []}
            isLoading={isGetOverStatisticsLoading}
            renderToolbarInternalActions={({ table }) => (
                <div onMouseDown={(e) => e.stopPropagation()}>
                    <MRT_ToggleGlobalFilterButton table={table} />
                </div>
            )}
        />
    );
};

export default OverallStatistics;
